import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';
import registerServiceWorker from './registerServiceWorker';

if (process.env.NODE_ENV === "development" && process.env.REACT_APP_ENABLE_MOCKS === "true") {
    require("./mockApi");
}

ReactDOM.render(<Router><App /></Router>, document.getElementById('root'));
registerServiceWorker();
